// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import MetadataLabel from './metadata-label';
import MetadataValueLabel from './metadata-value-label';

export const StatusValueType = {
  statusValue: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string,
  }),
};

export const StatusPropTypes = {
  statusLabel: PropTypes.string,
  statusValue: { ...StatusValueType },
  statusChoices: PropTypes.arrayOf(StatusValueType),
};

export default class MetadataField extends React.Component {
  static propTypes = {
    show: PropTypes.bool,
    editing: PropTypes.bool.isRequired,
    field: PropTypes.string.isRequired,
  };

  static defaultProps = {
    show: true,
  };

  render() {
    if (!this.props.show) {
      return null;
    }

    const { styles } = MetadataField;

    const classes = css(styles.container,
      this.classNames,
      this.props.editing && styles.editing);

    return (
      <div className={classes}>
        <div className={styles.content}>
          {this.renderContent()}
        </div>
      </div>
    );
  }

  renderContent() {
    const views = [];

    const { styles } = MetadataField;

    views.push((
      <MetadataLabel key={this.props.field}>
        {this.renderLabelContent()}
      </MetadataLabel>
    ));

    views.push((
      <div
        key="editable"
        className={styles.editableContent}
      >
        {this.renderEditableContent()}
      </div>
    ));

    return views;
  }

  renderEditableContent() {
    if (this.props.editing && this.renderEditable) {
      return this.renderEditable();
    } if (this.renderViewOnly) {
      return this.renderViewOnly();
    }

    return this.renderDefaultViewOnly();
  }

  renderDefaultViewOnly() {
    return (
      <MetadataValueLabel>
        {this.renderValueContent()}
      </MetadataValueLabel>
    );
  }

  renderLabelContent() {
    // nothing
  }

  renderValueContent() {
    // nothing
  }

  get classNames() {
    // nothing
  }
}

const styles = cssInJS({
  container: {
    width: '100%',
    opacity: 1,
    transform: 'scaleY(1)',
    transformOrigin: 'top',
    transition: 'transform 0.3s ease, opacity 0.3s ease',
    position: 'relative',
    padding: 0,
    clear: 'both',
    fontSize: 13,
    borderTop: '1px solid #c9c9c9',
    backgroundColor: '#e1e1e1',

    ':first-of-type': {
      borderTop: 'none',
    },
  },

  hidden: {
    overflow: 'hidden',
    opacity: 0,
    position: 'absolute',
    transform: 'scaleY(0)',
    transformOrigin: 'top',
    transition: 'transform 0.3s ease, opacity 0.1s ease',
  },

  editableContent: {
    display: 'inline-block',
    width: '58%',
    paddingRight: 12,

    '@phone': {
      display: 'block',
      width: '100%',
      paddingLeft: 8,
      paddingRight: 8,
      paddingBottom: 8,
      marginTop: -8,
    },
  },

  content: {
    display: 'flex',
    flexDirection: 'row',

    '@phone': {
      display: 'block',
    },
  },

  strong: {
    fontWeight: 'bold',
  },
});

MetadataField.styles = styles;
